<template>
  <mobile-main-navigation-component></mobile-main-navigation-component>
  <main class="main-container">
    <router-view></router-view>
  </main>
  <footer-component></footer-component>
</template>

<script>
import FooterComponent from './components/FooterComponent/FooterComponent.vue'
import MobileMainNavigationComponent from './components/MainNavigationComponent/MobileMainNavigationComponent.vue'
import './css/App.css';

export default {
  name: 'App',
  components: {
    FooterComponent,
    MobileMainNavigationComponent,
  }
}
</script>

<style>
#app {
  font-family: Helvetica, Helvetica Neue, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #42410b;
  background-color: var(--bg-dark);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  /* height: 75px; */
  margin: 0 auto;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main-container {
  position: relative;
  height: auto;
}
</style>
